import { Form, Formik, FormikProps } from 'formik';

import { Button } from '../../components';
import { InputField } from '../../fields';
import { ResetPasswordFormValues } from '../../models/User';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import { makePasswordResetSchema } from './schema';

interface Props {
  onSubmit: (values: ResetPasswordFormValues) => void;
  initialValues?: Partial<ResetPasswordFormValues>;
}

function ResetPasswordForm({ onSubmit, initialValues }: Props) {
  const { t } = useTranslation();
  const schema = makePasswordResetSchema(t);

  function handleOnSubmit(values: ResetPasswordFormValues) {
    onSubmit && onSubmit(values);
  }

  function renderForm(formikBag: FormikProps<ResetPasswordFormValues>) {
    return (
      <div className="login-form">
        <Form>
          <InputField
            name="email"
            label={t('resetPasswordForm.email.label')}
            placeholder={t('resetPasswordForm.email.placeholder')}
            size="large"
          />
          <Row justify="center" style={{ marginTop: '30px' }}>
            <Col>
              <Button htmlType="submit" type="primary" disabled={formikBag.isSubmitting}>
                {t('resetPasswordForm.submit')}
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  return (
    <Formik
      initialValues={{ email: initialValues?.email ?? '' }}
      onSubmit={handleOnSubmit}
      validationSchema={schema}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {renderForm}
    </Formik>
  );
}

export default ResetPasswordForm;
